<mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
  <mdb-carousel-item>
    <div class="view w-100">
      <img class="d-block w-100" src="../../../assets/bgt2.jpg" alt="First slide">
      <div class="mask rgba-black-light waves-light" mdbWavesEffect>
        <div class="row">
          <div id="bg_div_home" class="mx-auto centered text-center">
            <h2 [ngStyle]="{'color':colorSelected}" class="text-center">Abidar Yassine</h2>
            <p class="text-white  mx-auto " style="font-size: 20px;">
              On ne le fait jamais tant qu’il n’est pas rapide, réactif et correct. Mais si vous ne pouvez pas l’être,
              au moins soyez réactif. Si vous ne pouvez toujours pas être réactif, au moins être correct!
              <br>
              {{colorSelected}}
              <strong>Concevoir un site Web n’est pas une chose que vous faites. C’est un mode de vie.</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </mdb-carousel-item>
</mdb-carousel>